<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import PageLayout from 'dashboard/components-next/captain/PageLayout.vue';
import SettingsHeader from 'dashboard/components-next/captain/pageComponents/settings/SettingsHeader.vue';
import PromptVersionsList from 'dashboard/components-next/captain/pageComponents/assistant/settings/PromptVersionsList.vue';

const route = useRoute();
const assistantId = computed(() => Number(route.params.assistantId));
</script>

<template>
  <PageLayout
    :header-title="$t('CAPTAIN.ASSISTANTS.PROMPT_VERSIONS.TITLE')"
    :show-know-more="false"
    :show-pagination-footer="false"
  >
    <template #body>
      <SettingsHeader
        :heading="$t('CAPTAIN.ASSISTANTS.PROMPT_VERSIONS.TITLE')"
        :description="$t('CAPTAIN.ASSISTANTS.PROMPT_VERSIONS.DESCRIPTION')"
      />
      <div class="mt-4">
        <PromptVersionsList :assistant-id="assistantId" />
      </div>
    </template>
  </PageLayout>
</template>
